export const preparePieChartData = (data) => {
  return data.map((item) => {
    return {
      id: item.key,
      label: item.key,
      value: item.value,
      color: item.color,
    };
  });
};
